import * as React from "react";

export const ShareLeadIcon = (props: any) => (
  <svg
    width={56}
    height={56}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={4} y={4} width={48} height={48} rx={24} fill="#D1FADF" />
    <path
      d="M20 38a8 8 0 0 1 16 0H20Zm9-5.917V36h4.659A6.009 6.009 0 0 0 29 32.083ZM27 36v-3.917A6.008 6.008 0 0 0 22.341 36H27Zm1-7c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6Zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Z"
      fill="#333"
    />
    <rect
      x={4}
      y={4}
      width={48}
      height={48}
      rx={24}
      stroke="#ECFDF3"
      strokeWidth={8}
    />
  </svg>
);
